











































































import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProductEntity } from '@/entities/product.entity';
import CPrimaryBtn from '@/components/Helper/Button/CBorderBtn.vue';
import NewIcon from '@/components/Helper/Icon/Svg/NewIcon.vue';
import { UseService } from '@/services/service';
import OrderService from '@/services/order.service';
import DialogOrderSuccess from '@/components/ViewComponent/Exchange/DialogOrderSuccess.vue';
import CheeersCoinIcon from '@/components/Helper/Icon/Svg/CheeersCoinIcon.vue';

@Component<ProductItemDetail>({
  components: {
    CheeersCoinIcon,
    NewIcon,
    CPrimaryBtn,
    DialogOrderSuccess,
  },
})
export default class ProductItemDetail extends Vue {
  @Prop({ type: Object as PropType<ProductEntity> })
  product: ProductEntity;

  @Prop({ type: Boolean })
  value: boolean;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit('input', value);
  }

  successDialog = false;

  isDisabled = false;

  @UseService(OrderService)
  service: OrderService;

  async order() {
    try {
      this.isDisabled = true;
      await this.service.createOne({
        details: [{ productId: this.product.id, quantity: 1 }],
      });
      this.successDialog = true;
      this.dialog = false;
    } catch (e) {
      await this.$cheeers.notify({
        text: this.$t(`exchange.itemDetail.${e.response.data.message}`),
        type: 'error',
      });
    } finally {
      this.isDisabled = false;
    }
  }
}
